import * as D from "@radix-ui/react-dialog"
import { cn, tv } from "@utils/tw"
import { ReactNode } from "react"

export type AlertDialogProps = {
  title?: ReactNode
  description?: ReactNode
  className?: string
  asForm?: boolean
  onDismiss?: (e: Event) => void
  open?: boolean
  onOpenChange?: (open: boolean) => void
  /**
   * The trigger element that will open the dialog when clicked.
   */
  trigger?: ReactNode
  /** The contents of the dialog */
  children?: ReactNode
}

export function Dialog(props: AlertDialogProps) {
  const styles = alertStyles()

  return (
    <D.Root
      open={props.open}
      onOpenChange={(open) => {
        props.onOpenChange?.(open)
      }}
    >
      {props.trigger && <D.Trigger asChild>{props.trigger}</D.Trigger>}
      <D.Portal>
        <D.Overlay className={styles.overlay()} />
        <D.Content
          className={styles.content({ className: props.className })}
          asChild
          // onEscapeKeyDown={(e) => {
          //   requestCancel(e)
          // }}
        >
          <div>
            {props.title && <D.Title className={styles.title()}>{props.title}</D.Title>}
            {props.description && <D.Description className={styles.description()}>{props.description}</D.Description>}
            {props.children}
          </div>
        </D.Content>
      </D.Portal>
    </D.Root>
  )
}

Dialog.Title = D.Title
Dialog.Description = D.Description
Dialog.Close = D.Close

const alertStyles = tv({
  slots: {
    overlay: "radix-backdrop",
    content: [
      "radix-modal-animation @container-normal",
      "fixed z-50 left-1/2 top-1/2 max-h-[85vh] max-w-[90vw] -translate-x-1/2 -translate-y-1/2",
      "rounded-md bg-bg text-fg p-5 shadow-popover focus:outline-none",
      "flex flex-col",
    ],
    title: "type-title-m",
    description: "mb-5 mt-[15px] type-body",
    buttons: "flex justify-end gap-[25px]",
  },
})
